import React, {useMemo} from "react";
import Chips, {ChipsContentType, ChipsTypes} from "../../../../../../../../components/base/chips/chips";
import TagChipsContent from "../../../../../../../../components/app-specific/chips-contents/tag-chips-content";
import LazyImage from "../../../../../../../../components/app-specific/lazy-image";
import {useBizFileUrlsResolver} from "../../../../../../../../hooks/use-biz-file-urls-resolver";

const UserHomepageControlPanelCarouselImageEntity = ({image}) => {
    const bizFileUrls = useBizFileUrlsResolver((t) => t.bizFile);
    const imageSrc = useMemo(() => bizFileUrls.getFilePreviewUrl(image?.fileGuid, image?.fileExtension) ?? image?.mockPreviewUrl, [bizFileUrls, image?.fileGuid, image?.fileExtension, image?.mockPreviewUrl]);

    return (
        <div className={'User-homepage-control-panel-carousel-image'}>
            <div className={'image-preview'}>
                <LazyImage
                    src={imageSrc}
                    alt={image?.tags?.[0]?.name ?? 'carousel image'}
                    height={80}
                />
            </div>
            {
                !!image?.tags?.length &&
                <div className={'tags-container'}>
                    {image.tags.map(tag => (
                        <Chips
                            key={tag.id}
                            className={'tag'}
                            type={ChipsTypes.none}
                            contentType={ChipsContentType.element}
                            content={<TagChipsContent tag={tag} useIcon/>}
                        />
                    ))}
                </div>
            }
        </div>
    );
}

export default UserHomepageControlPanelCarouselImageEntity;
